module.exports = __webpack_public_path__ + "static/mechanical-damage-ffe45d9e70158d554d22384a80e65275.png";